import { Flex } from "@chakra-ui/react";
import Features from '../home/components/features';
import SEO from '../components/SEO';
import { useTranslation } from '../i18n/LanguageContext';

export default function FeaturesPage() {
  const { t } = useTranslation();

  return (
    <main>
      <SEO
        title={t("seo.features.title")}
        description={t("seo.features.description")}
        path="/features"
      />
      <Flex
        flexDirection={"column"}
        alignItems={"center"}
        p={"20px"}
        gap={"50px"}
      >
        <Features />
      </Flex>
    </main>
  );
}
